/* =====================================================
   THE LORD RAZU — SHOP FOUNDATION
   Shared storefront controller.
   ===================================================== */

(() => {
  "use strict";

  if (window.LordRazuShop) return;

  const SHARED_MUSIC_CATALOG =
    "https://thelordrazu.github.io/thelordrazu/Music/catalog.json";

  let catalogPromise = null;

  async function getMusicCatalog({ refresh = false } = {}) {
    if (refresh) catalogPromise = null;

    if (!catalogPromise) {
      catalogPromise = fetch(SHARED_MUSIC_CATALOG, { cache: "no-cache" })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Music catalog request failed: ${response.status}`);
          }
          return response.json();
        })
        .catch((error) => {
          catalogPromise = null;
          console.error("[The Lord Razu Shop] Catalog load failed:", error);
          throw error;
        });
    }

    return catalogPromise;
  }

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
      return;
    }
    callback();
  }

  ready(() => {
    document.documentElement.dataset.razuShop = "ready";
  });

  window.LordRazuShop = Object.freeze({
    version: "1.0.0",
    catalogUrl: SHARED_MUSIC_CATALOG,
    getMusicCatalog,
  });
})();
